<template>
    <div id="product-configurator" :class="product != null && product.Product != null && product.Product.ProductType == 2 && partnumbersByColor != undefined && partnumbersByColor.length == 1 ? 'one-size' : ''" v-if="product && product.ShowProductSelector == true && viewmode != 'axapta'">
        <V12 :V12Label="product.V12Label" :V12FinanceProducts="product.V12FinanceProducts" :Amount="partnumber != null ? partnumber.price : product.Partnumbers[0].price" v-if="product.V12FinanceProducts != undefined && product.V12FinanceProducts.length > 0"></V12>

        <!--Addons Description when available-->
        <p id="bundlesIntro" v-if="bundles && bundles.length > 0 && getInterfaceText('shop_bundles_intro').length > 0" style="margin:20px 0" v-html="getInterfaceText('shop_bundles_intro')"></p>
        <div style=" border-top: 1px dotted #aaa; border-bottom: 1px dotted #aaa;padding:10px 0;">
            <!-- 2 or more colors: circles-->
            <template v-if="product.ColorCodes && product.ColorCodes.length > 1 && hasUsage == false">
                <!--WDR 20230309: Indien Partnumber.Usage waardes heeft dan Colour waardes negeren. -->
                <h4>{{getInterfaceText('shop_selectcolor')}}</h4>
                <div class="colors">
                    <template v-for="item in product.ColorCodes" :key="item.Description">
                        <input type="radio" name="color" :value="item.Description" :id="'radio' + item.Description" v-model="color" />
                        <label :for="'radio' + item.Description" :class="color == item.Description ? 'selected' : ''" :title="item.Description">
                            <i class="icongiant-check"></i>
                            <span class="circle-border">
                                <span class="circle" :style="{ backgroundColor: '#'+item.HexCodePrimary }"></span>
                                <span :v-if="item.HexCodePrimary" class="halfcircle" :style="{ backgroundColor: '#'+item.HexCodeSecondary }"></span>
                            </span>
                            <span class="text">{{item.Description}}</span>
                        </label>
                    </template>
                </div>
            </template>
            <template v-else-if="hasUsage == true">
                <h4>{{getInterfaceText('shop_selectyourversion')}}</h4>
            </template>

            <!--e-commerce block-->
            <div v-if="product.ShopActive">
                <!-- size blocks with extra info and dealers -->
                <div class="sizes">
                    <div class="row row-heading" v-show="product.Product != null && product.Partnumbers != null && product.Partnumbers.length > 1">
                        <div class="col-md-6" v-show="hasUsage == false"><h4>{{getInterfaceText('shop_chooseyoursize')}}</h4></div>
                        <div class="col-md-6" v-show="(product.Product.SizingSheetUrl != undefined && product.Product.SizingSheetUrl.length > 0) || product.Product.HasFrameSizes || product.SmartfitAvailable">
                            <div class="whatismysize" v-if="showBikeAdvancedSizingTool">
                                <a href="#" v-on:click="trackEventBikeAdvancedSizingTool" data-toggle="modal" data-target="#advancedSizingToolModal">{{getInterfaceText('shop_whatismysize')}}</a>
                            </div>
                            <div class="whatismysize" v-else-if="product.SmartfitAvailable">
                                <!-- Smart Fit V2 -->
                                <a href="javascript:void(0);"
                                   id="custom-oz-button"
                                   class="oz-trigger"
                                   :data-oz-code="product.Partnumbers[0].Barcode"
                                   :data-oz-name="product.Product.Name"
                                   :data-oz-image="(product.Product.CloudinaryImagesToPartnumbers.length > 0 ? product.Product.CloudinaryImagesToPartnumbers[0].CloudinaryImage.ImageUrlMain : '')"
                                   data-oz-fullscreen="true"
                                   onclick="trackEventGlobalAndLocal('Size', 'Standard', 'SmartFit');">{{getInterfaceText('shop_whatismysize')}}</a>
                            </div>
                            <div class="whatismysize" v-else-if="product.Product != null && product.Product.SizingSheetUrl != undefined && product.Product.SizingSheetUrl.length > 0">
                                <a data-fancybox :href="product.Product.SizingSheetUrl" onclick="trackEventGlobalAndLocal('Size', 'Standard', 'Sizing sheet');">{{getInterfaceText('shop_whatismysize')}}</a>
                            </div>
                            <div class="whatismysize" v-else-if="product.Product !=null && product.Product.HasFrameSizes">
                                <a href="#geometry" id="bikeframesize-geometry-tab" class="act-like-tab-click" onclick="trackEventGlobalAndLocal('Size', 'Standard', 'Frame sizes');" style="color: #676767;"><i class="glyphicon glyphicon-question-sign"></i> {{getInterfaceText('shop_whatismysize')}}</a>
                            </div>
                            <div class="whatismysize" v-else>
                                <!--nothing-->
                            </div>
                        </div>
                        <!--<div v-show="(product.Product.SizingSheetUrl != undefined && product.Product.SizingSheetUrl.length > 0) || product.Product.HasFrameSizes || product.SmartfitAvailable">
                        <div class="col-md-6 whatismysize" v-if="product.SmartfitAvailable">-->
                        <!-- Smart Fit V2 -->
                        <!--<button style="padding: 5px 10px; margin-bottom: 15px; font-size: 14px; background:#eee; border:1px solid #ddd; display:block;"
                                    id="custom-oz-button"
                                    class="oz-trigger"
                                    :data-oz-code="product.Partnumbers[0].Barcode"
                                    :data-oz-name="product.Product.Name"
                                    :data-oz-image="(product.Product.CloudinaryImagesToPartnumbers.length > 0 ? product.Product.CloudinaryImagesToPartnumbers[0].CloudinaryImage.ImageUrlMain : '')"
                                    data-oz-fullscreen="true"
                                    onclick="trackEventGlobalAndLocal('Size', 'Standard', 'SmartFit');">
                                <i class="glyphicon glyphicon-new-window" aria-hidden="true"></i>
                                {{getInterfaceText('shop_whatismysize')}}
                            </button>
                        </div>
                        <div class="col-md-6 whatismysize" v-else-if="product.Product != null && product.Product.SizingSheetUrl != undefined && product.Product.SizingSheetUrl.length > 0">
                            <a data-fancybox :href="product.Product.SizingSheetUrl" onclick="trackEventGlobalAndLocal('Size', 'Standard', 'Sizing sheet');">{{getInterfaceText('shop_whatismysize')}}</a>
                        </div>
                        <div class="col-md-6 whatismysize" v-else-if="product.Product !=null && product.Product.HasFrameSizes">
                            <a href="#geometry" id="bikeframesize-geometry-tab" class="act-like-tab-click" onclick="trackEventGlobalAndLocal('Size', 'Standard', 'Frame sizes');" style="color: #676767;"><i class="glyphicon glyphicon-question-sign"></i> {{getInterfaceText('shop_whatismysize')}}</a>
                        </div>
                        <div class="col-md-6 whatismysize" v-else>-->
                        <!--nothing-->
                        <!--</div>
                        </div>-->
                    </div>

                    <template v-for="item in partnumbersByColor" :key="item.code">
                        <!-- SIZE -->
                        <div v-if="hasPartnumberInCart(item.code)" class="size added-to-cart clearfix">

                            <span class="description" v-show="item.description">{{item.description}}</span>
                            <span v-if="item.globalFrameSize != undefined && item.globalFrameSize.length > 0"> ({{item.globalFrameSize}})</span>
                            <br />
                            <span class="added-text"><i class="icongiant-check" aria-hidden="true"></i> {{getInterfaceText('shop_added_to_cart')}}</span>
                            <button class="btn btn-remove" v-on:click="removePartnumberFromCart(item.code);removeSelectedDealer()" title="Remove from cart"><i class="glyphicon glyphicon-trash"></i></button>
                            <br />
                            <a :href="'/' + culture + '/shop/review'" class="btn btn-success">{{getInterfaceText('shop_proceedtocheckout')}}</a>

                        </div>
                        <div class="size" :class="item == partnumber ? 'size-selected' : ''" :id="item.code" v-if="hasPartnumberInCart(item.code) == false">
                            <button class="name-and-stockinfo" v-on:click="togglePartnumber(item)">
                                <div class="name">
                                    {{item.description}}
                                    <span v-if="item.globalFrameSize != undefined && item.globalFrameSize.length > 0">({{item.globalFrameSize}})</span>
                                    <span v-if="product.PriceDifferences">({{item.priceToFormat}})</span>
                                </div>
                                <div class="stockinfo" :class="item.stock.CssClass">{{item.stock.Label}}</div>
                                <div class="notify-me" v-show="product.Partnumbers.length > 1" v-if="item && item.stock.Code == 0 && item.notifyMe == true">{{getInterfaceText('shop_notifywhenavailable')}}</div>
                            </button>
                            <div class="extra-info" :aria-expanded="item == partnumber" v-if="item == partnumber && hasPartnumberInCart(item.code) == false">
                                <div id="selected-partnumber" v-if="partnumber != null && partnumber.code.length > 0">{{getInterfaceText('shop_product_item#')}} {{ partnumber.code }}</div>
                                <div id="dealerSelector" v-if="item.stock.Code > 0">
                                    <div v-if="pickupAvailable == true">
                                        <p class="stock-message" v-if="countryId == 14">
                                            <!--no label for France-->
                                        </p>
                                        <p class="stock-message" v-else-if="item.stock.Code == 1 && product.Product.ProductType == 1 && item.stock.IsRetailDirectToConsumer == false">
                                            {{getInterfaceText('shop_shipsfromwarehouseandwillbeavailableforpickup')}}
                                            <span v-if="isStore == false">
                                                {{label_shop_at_any_retailer}}
                                            </span>&nbsp;<strong>{{getInterfaceText('shop_inabout7businessdays.')}}</strong> <a href="javascript:void(0)" v-on:click="onPickupAtAnyRetailerClick()" id="findLocalStock" v-if="item.stock.ContainsLocalstock == false">{{getInterfaceText('find_your_giant_retailer')}}</a>
                                            <span v-if="showShippingCostsAtProductSelector == true && item.shippingCosts.length > 0">&nbsp;{{getInterfaceText('shop_warehouse_shipping_costs')}} {{item.shippingCosts}}</span>
                                        </p>
                                        <p class="stock-message" v-else-if="item.stock.Code == 3">
                                            {{getInterfaceText('shop_shipsfromwarehouseandwillbeavailableforpickup-preorder1')}}&nbsp;<strong>{{getInterfaceText('shop_shipsfromwarehouseandwillbeavailableforpickup-preorder2')}}&nbsp;{{item.stock.DateExpectedToFormat}}</strong>&nbsp;{{getInterfaceText('shop_shipsfromwarehouseandwillbeavailableforpickup-preorder3')}}
                                            <a href="javascript:void(0)" v-if="isStore == false" v-on:click="onPickupAtAnyRetailerClick()" id="findLocalStock">
                                                {{label_shop_at_any_retailer}}
                                            </a>
                                            {{getInterfaceText('shop_shipsfromwarehouseandwillbeavailableforpickup-preorder4')}}
                                            <strong>{{getInterfaceText('shop_shipsfromwarehouseandwillbeavailableforpickupabout-preorder5')}} <span v-if="item.stock.DateExpectedToWeeks <= 1">1 {{getInterfaceText('shop_week')}}</span><span ng-show="item.stock.DateExpectedToWeeks > 1">{{item.stock.DateExpectedToWeeks}}-{{item.stock.DateExpectedToWeeks + 1}} {{getInterfaceText('shop_weeks')}}</span></strong>

                                        </p>
                                    </div>
                                    <!-- add to cart button -->
                                    <div class="add-to-cart" v-if="isAddToCartButtonVisible(item)">
                                        <button class="btn btn-addtocart" v-on:click="addCartItem(item.code, product.Product.Id, product.Product.ProductType, product.Product)">{{getInterfaceText('add_to_cart')}}</button>
                                    </div>

                                    <div v-show="partnumber.stock.IsRetailDirectToConsumer == false && hasLocalStockDealers()">
                                        <p class="stock-message">
                                            <span v-if="item.stock.Code == 2 || item.stock.Code == 3" v-html="label_shop_inStoreNowAndAvailableForPickup.replace('{{ dealerSearchCity }}',dealerSearchCity)"></span>
                                            <span v-else-if="item.stock.Code == 1 && hasLocalStockDealersWithinRadius()" v-html="label_shop_orPickItUpAtStore.replace('{{ dealerSearchCity }}',dealerSearchCity)"></span>
                                        </p>

                                        <!--<p class="in-store-now stock-message" v-if="pickupAvailable && hasLocalStockDealers && hasLocalStockDealersWithinRadius() == false">-->
                                        <p class="in-store-now stock-message" v-if="item.stock.Code == 1 && hasLocalStockDealers && hasLocalStockDealersWithinRadius() == false">
                                            <span v-html="label_shop_ifYouAreWillingToTakeARoadTrip.replace('{{ dealerSearchCity }}','<strong>' + dealerSearchCity + '</strong>')"></span>
                                            <span v-if="showShippingCostsAtProductSelector == true">
                                                <span v-html="getInterfaceText('shop_ifyouarewillingtotakearoadtrip_safe_shippingcosts')"></span>
                                                &nbsp;{{item.shippingCosts}}
                                            </span>
                                        </p>
                                    </div>

                                    <!-- dealer already selected or not? -->
                                    <div v-if="isStore == false">
                                        <div v-show="partnumber.stock.IsRetailDirectToConsumer == true && partnumber.stock.ContainsLocalstock == true">
                                            <a href="javascript:void(0)" v-on:click="setShowDealerSelector = !setShowDealerSelector;">
                                                <span v-show="setShowDealerSelector == false">{{getInterfaceText('shop_rd2c_showretailersthathaveinstore')}}</span>
                                                <span v-show="setShowDealerSelector == true">{{getInterfaceText('shop_rd2c_hideretailersthathaveinstore')}}</span>
                                            </a>
                                        </div>
                                        <div v-show="showDealerSelector == true">
                                            <template v-if="isSelectedDealerInfoVisible(item)">

                                                <!-- YES a dealer has been selected -->
                                                <div class="selected-dealer-wrapper">
                                                    <DealerSelect :dealer="selectedDealer"
                                                                  :selectedDealer="selectedDealer"
                                                                  :isInStoreNowTextVisible="isInStoreNowTextVisible"
                                                                  :isAvailableInTextVisible="isAvailableInTextVisible"
                                                                  :sellLocalStock="sellLocalStock"
                                                                  v-on:select-dealer-and-add-to-cart="selectDealerAndAddToCart"
                                                                  v-on:remove-selected-dealer="removeSelectedDealer"></DealerSelect>
                                                </div>

                                            </template>
                                            <template v-else>
                                                <!-- NO selected dealer yet -->
                                                <!-- title -->
                                                <h4 v-show="isDealerSearchFieldEnabled" class="select-a-dealer">
                                                    <span v-show="partnumber.stock.IsRetailDirectToConsumer == false">{{getInterfaceText('shop_findwherebikeisinstore')}}</span>
                                                    <span v-show="partnumber.stock.IsRetailDirectToConsumer == true">{{getInterfaceText('shop_rd2c_findwherebikeisinstore', product.Product.Name + ' (' + item.description + ', ' + item.color + ')')}}</span>
                                                </h4>

                                                <!-- dealer search  -->
                                                <div class="form-group" rel="tooltip" data-placement="left" v-show="isDealerSearchFieldEnabled">
                                                    <div class="wrapper-floating-label-and-buttongroup clearfix">
                                                        <div class="wrapper-floating-label" :class="{ 'movelabel' : dealerSearchCity != null && dealerSearchCity != '' }">
                                                            <label for="inputFindLocalStock">{{getInterfaceText('shop_searchonzipcodeorcity')}}</label>
                                                            <input type="text" v-model="dealerSearchCity" ref="zipcodeCityInput" v-on:keyup.enter="getDealersByLocation()" id="inputFindLocalStock" />
                                                        </div>
                                                        <div class="input-group input-group-floating-label-style">
                                                            <span class="input-group-btn">
                                                                <button type="button" class="btn btn-storefinder" id="btnFindLocalStock" v-on:click="getDealersByLocation()"><i class="glyphicon glyphicon-map-marker" aria-hidden="true"></i></button>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="alert alert-danger" v-show="exceptionMessageDealers.length > 0">{{exceptionMessageDealers}}</div>
                                                </div>

                                                <!-- local stock only checkbox -->
                                                <label for="filterOnlyLocalStock" class="filter-on-local-stock" v-if="isLocalStockFilterCheckboxVisible() && partnumber.stock.IsRetailDirectToConsumer == false">
                                                    <input type="checkbox" v-model="isLocalStockOnlyMode" v-on:change="toggleLocalStockOnlyMode()" id="filterOnlyLocalStock" />
                                                    {{getInterfaceText('shop_onlyshowdealershaveinstore')}}
                                                </label>

                                                <!-- dealers to select -->
                                                <div class="dealers" v-if="isDealerListVisible">
                                                    <div v-if="loadingDealers" class="loading">{{getInterfaceText('loading')}}</div>
                                                    <div v-if="isDealerListVisible && !loadingDealers">
                                                        <template v-for="dealer in activeDealers" :key="dealer.Code">
                                                            <DealerSelect :dealer="dealer"
                                                                          :selectedDealer="selectedDealer"
                                                                          :isInStoreNowTextVisible="dealer.Type == 'local'"
                                                                          :isAvailableInTextVisible="isAvailableInTextVisible"
                                                                          :sellLocalStock="sellLocalStock"
                                                                          :partnumber="partnumber"
                                                                          :product="product"
                                                                          v-on:select-dealer-and-add-to-cart="selectDealerAndAddToCart"
                                                                          v-on:remove-selected-dealer="removeSelectedDealer"></DealerSelect>
                                                        </template>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="item && item.stock.Code != 1 && item.notifyMe == true && (item.stock.IsRetailDirectToConsumer == false || item.stock.Code == 0) && showNotifyMe == false" style="margin: 20px 0 0 0; border-top: 1px solid #ccc; padding: 10px 0 0 0;">
                                    <p v-html="getInterfaceText('shop_productoutofstockcontactlocalstore')" v-if="item.stock.Code == 0"></p>
                                    <a href="javascript:void(0);" v-on:click="toggleNotifyMeForm" class="btn btn-default">
                                        <i class="glyphicon glyphicon-envelope" aria-hidden="true"></i>
                                        {{getInterfaceText('shop_notifywhenavailable')}}
                                    </a>
                                </div>
                                <div class="no-stock-wrapper" v-if="showNotifyMe == true" style="margin-top:20px;">
                                    <p v-if="isStore == true && getInterfaceText('shop_productoutofstockcontactstore').length > 0 && item.stock.Code == 0" v-html="getInterfaceText('shop_productoutofstockcontactstore')"></p>
                                    <p v-if="product.Partnumbers.length > 1 && item.stock.Code == 0" v-html="getInterfaceText('shop_productoutofstockcontactlocalstore')"></p>
                                    <template v-if="item.notifyMe == true">
                                        <NotifyMe :partnumberCode="item.code"></NotifyMe>
                                    </template>
                                    <!--<template v-else>
                                        <p v-html="getInterfaceText('shop_productoutofstockcontactlocalstore')"></p>
                                    </template>-->
                                </div>
                            </div>
                        </div>
                    </template>

                    <a data-fancybox data-type="iframe" href="javascript:void(0);" v-if="product.WhyPickItUpInStorePageUrl != null && product.WhyPickItUpInStorePageUrl.length > 0" :data-src="product.WhyPickItUpInStorePageUrl">{{getInterfaceText('page_whypickupinstore_link_label')}}</a>
                </div>
                <p class="sizingnote" v-show="product.Product.SizingNote != null">{{product.Product.SizingNote}}</p>
            </div>

            <div class="alert alert-danger" v-show="exceptionMessageCart != undefined && exceptionMessageCart.length > 0">{{exceptionMessageCart}}</div>

            <div class="addons" v-if="addOns && addOns.length > 0">
                <h4>{{getInterfaceText('shop_choose_add_ons')}}</h4>
                <template v-for="addon in addOns" :key="addon.Id">

                    <div class="item" v-on:mouseover="showAddOnOverlayImage(addon)" v-on:mouseout="hideAddOnOverlayImage(addon)" :class="{ 'item-selected' : hasProductInCart(addon.GearGlobalProductId) }">
                        <div class="text">
                            <h5>
                                {{ addon.Name }}
                                <button class="btn btn-info" v-if="addon.Description" type="button" data-toggle="collapse" :data-target="'#collapseItem'+ addon.Id" aria-expanded="false" aria-controls="'collapseItem'+ addon.Id">i</button>
                            </h5>
                            <div class="collapse extra-info" :id="'collapseItem'+ addon.Id">
                                <div class="padding">
                                    {{ addon.Description }}
                                </div>
                            </div>
                            <p style="margin-bottom:0;">
                                {{ addon.PriceToFormat }}
                            </p>
                            <button class="btn btn-add" v-show="hasProductInCart(addon.GearGlobalProductId) == false" v-on:click="addCartItem(addon.PartnumberCode, addon.GearLocalProductId, 2, addon, addon.Partnumber);animateAddOn($event)">{{getInterfaceText('add_to_cart')}}</button>
                            <div class="added" v-show="hasProductInCart(addon.GearGlobalProductId)">
                                <span class="added-text"><i class="icongiant-check" aria-hidden="true"></i> {{getInterfaceText('shop_added_to_cart')}}</span>
                                <button class="btn btn-remove" v-on:click="removePartnumberFromCart(addon.PartnumberCode)" title="Remove from cart"><i class="glyphicon glyphicon-trash"></i></button>
                            </div>
                        </div>
                        <div class="image">
                            <a v-if="addon.CloudinaryImageGearProduct" :href="addon.CloudinaryImageGearProduct.ImageUrlZoom" class="galleryzoom" data-fancybox="gallery"><img :src="addon.CloudinaryImageGearProduct.ImageUrlSmall" /></a>
                        </div>
                    </div>
                </template>

            </div>
            <div class="bundles" v-if="bundles && bundles.length > 0">
                <h4>{{getInterfaceText('shop_choose_bundles')}}</h4>
                <p v-if="getInterfaceText('shop_choose_bundles_disclaimer').length > 0" style="font-size: 12px;">{{getInterfaceText('shop_choose_bundles_disclaimer')}}</p>
                <template v-for="bundle in bundles" :key="bundle">
                    <BundleItem :bundle="bundle"></BundleItem>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import vueStore from '../../store/store.js';
    import cartMixin from '../../mixins/cart-mixin.js';
    import generalMixin from '../../mixins/general.js';
    import NotifyMe from '@/components/NotifyMe.vue';
    import DealerSelect from '@/components/DealerSelect.vue';
    import BundleItem from '@/components/BundleItem.vue';
    import V12 from '@/components/V12.vue';

    export default {
        mixins: [cartMixin, generalMixin],
        components: {
            NotifyMe,
            DealerSelect,
            BundleItem,
            V12
        },
        data: function () {
            return {
                exceptionMessageCart: '',
                exceptionMessageDealers: '',
                dealerSearchCity: '',
                isDealerListVisible: true,
                isDealerSearchFieldEnabled: false,
                isClientSearchFieldEnabled: false,
                isLocalStockOnlyMode: true,
                isWillingToTakeARoadTrip: false,
                isInStoreNowTextVisible: true,
                isAvailableInTextVisible: true,
                activeDealers: [],
                isNotifyMeVisible: false,
                loadingDealers: true,
                isStore: window.store.length > 0,
                pickupAvailable: false,
                showShippingCostsAtProductSelector: false,
                label_shop_inStoreNowAndAvailableForPickup: window.label_shop_inStoreNowAndAvailableForPickup,
                label_shop_orPickItUpAtStore: window.label_shop_orPickItUpAtStore,
                label_shop_at_any_retailer: window.label_shop_at_any_retailer,
                label_shop_ifYouAreWillingToTakeARoadTrip: window.label_shop_ifYouAreWillingToTakeARoadTrip,
                id: '',
                producttypeid: '',
                culture: window.culture,
                countryId: window.countryId,
                partnumberDefault: '',
                setShowDealerSelector: false,
                addingProductToCart: false,
                showBikeAdvancedSizingTool: false,
                viewmode: ''
            }
        },
        mounted() {
            //console.log('Hello from product-configurator component.');
        },
        methods: {
            async fetchApi() {
                await axios.get(this.apiUrl)
                    .then((response) => {
                        vueStore.commit('setProduct', response.data)

                        //set default values
                        if (this.partnumberDefault.length > 0) {
                            var partnumber = response.data.Partnumbers?.filter(x => x.code == this.partnumberDefault)
                            if (partnumber.length > 0) {
                                vueStore.commit('setPartnumber', partnumber[0]);
                                this.color = partnumber[0].color;
                                //this.shippingOption = this.getFirstShippingOptionAvailable();
                            }
                        }
                    })
            },
            removeSelectedDealer() {
                vueStore.commit('setDealer', null);
            },
            selectDealerAndAddToCart(dealer) {
                // set  dealer in vue-store
                vueStore.commit('setDealer', dealer);

                // add to cart
                this.addCartItem(this.partnumber.code, this.id, this.producttypeid, this.product.Product);
            },
            togglePartnumber(partnumber) {
                //set partnumber to null if partnumber is already selected (toggle)
                if (this.partnumber != null && this.partnumber.code == partnumber.code) {
                    partnumber = null;

                    // commit action to store
                    vueStore.commit('setPartnumber', partnumber);

                    //set default shipping option
                    //this.shippingOption = this.getFirstShippingOptionAvailable();
                } else {
                    this.setPartnumberAndGetDealers(partnumber);
                }

                if (partnumber != null && this.product.HasVariations && this.product.Colors.length <= 1) { //set different image
                    vueStore.state.activeImage = this.cloudinaryImageByPartnumberCode(partnumber.code);
                }

                //track GA
                window.trackEventGlobalAndLocal('Select your size', 'Click', document.title);

                //GA4
                if (partnumber != null && this.product.Partnumbers.length > 1) {
                    window.trackEventGlobalAndLocalGA4({ 'ga4_name': 'select_size', 'ga4_model_category': this.product.Product.GA_Category, 'ga4_model_name': this.product.Product.Name, 'ga4_click_text': partnumber.description });
                }
            },
            setPartnumberAndGetDealers(partnumber) {
                // remove selected dealer
                this.removeSelectedDealer();
                // reset dealer search settings
                this.resetDealerSearch();
                //reset notify me form
                this.isNotifyMeVisible = false;
                this.setShowDealerSelector = false;

                // commit action to store
                vueStore.commit('setPartnumber', partnumber)

                // check stock code - if not 0 (soldout), only bikes and no store site then get dealers by location
                //if (partnumber != null && this.product.Product.ProductType == 1 && partnumber.stock.Code != 0 && (window.store == undefined || window.store.length == 0)) {
                //    this.getDealersByGeocode(this.clientLocation.lat, this.clientLocation.lng)
                //}
                if (partnumber != null && this.product.SellLocalStock == true && partnumber.stock.Code != 0 && partnumber.stock.ContainsLocalstock == true && (window.store == undefined || window.store.length == 0)) {
                    this.getDealersByGeocode(this.clientLocation.lat, this.clientLocation.lng)
                }

                //set default shipping option
                //this.shippingOption = this.getFirstShippingOptionAvailable();
            },
            //setShippingOption(shippingoption) {
            //    this.shippingOption = shippingoption;
            //},
            resetDealerSearch() {
                this.isWillingToTakeARoadTrip = false;
                this.isDealerSearchFieldEnabled = false;
                this.isDealerListVisible = false;
                this.isLocalStockOnlyMode = true;
            },
            showAddOnOverlayImage(addon) {
                if (!this.hasProductInCart(addon.GearGlobalProductId)) {
                    addon.IsSelected = true;
                }
            },
            hideAddOnOverlayImage(addon) {
                if (!this.hasProductInCart(addon.GearGlobalProductId)) {
                    addon.IsSelected = false;
                }
            },
            getDealersByGeocode(lat, lng) {

                console.log("getDealersByGeocode");

                var that = this;
                this.exceptionMessageDealers = '';

                // define url
                var url = '/' + window.culture + '/shop/dealers2' + (window.store != undefined && window.store.length > 0 ? '?store=' + window.store : '');

                // create object
                var myDealerRequest = {
                    partnumberCode: this.partnumber.code,
                    productId: this.id,
                    productType: this.producttypeid,
                    latitude: lat != undefined ? lat : window.defaultLatitude,
                    longitude: lng != undefined ? lng : window.defaultLongitude
                }

                // call api
                axios({
                    method: "post",
                    url: url,
                    data: myDealerRequest,
                })
                    .then(function (response) {
                        //handle success
                        if (response.data) {
                            // put data in store
                            vueStore.commit('setDealers', response.data)

                            // Set the active dealers with logic based on the data
                            that.setActiveDealers()


                        }

                    })
                    .catch(function (response) {
                        //handle error
                        that.exceptionMessageDealers = response;
                        console.error(response)
                    });
            },
            getDealersByLocation() {

                this.loadingDealers = true;
                this.exceptionMessageDealers = '';
                var callback = function (that, lat, lng) {

                    if (lat != undefined) {
                        that.getDealersByGeocode(lat, lng);
                        that.isClientSearchFieldEnabled = false;
                    } else {
                        // do we need something here?
                        that.exceptionMessageDealers = 'Could not find this place'
                    }
                };

                this.setClientLocation(this.dealerSearchCity, callback, this);
            },
            isSelectedDealerInfoVisible(item) {
                return (this.selectedDealer && this.selectedDealer?.Code && item && item.stock.Code > 0 && this.inProgressAddingProductToCart == false);
            },
            hasWarehouseDealers() {
                return (this.dealers?.filter(x => x.Type == 'warehouse').length > 0);
            },
            hasLocalStockDealers() {
                return (this.dealers?.filter(x => x.Type == 'local').length > 0);
            },
            hasLocalStockDealersWithinRadius() {
                return (this.dealers?.filter(x => x.Type == 'local' && x.IsDealerWithinRadius == true).length > 0);
            },
            hasAnyDealers() {
                return (this.hasWarehouseDealers() || this.hasLocalStockDealers());
            },
            isAddToCartButtonVisible(item) {
                var enable = false;
                // can we show the ADD TO CART button?
                //if (this.product && this.product.Product && item && item.stock.Code > 0 && this.hasWarehouseDealers()) {
                //    // scenario 1: warehouse stock dealers AND stock > 0
                //    enable = true;
                //}
                if (this.product && this.product.Product && item && (item.stock.Code == 1 || item.stock.Code == 3)) {
                    // scenario 1: warehouse or pre-order stock available
                    enable = true;
                }
                else if (this.product && this.product.Product && item && item.stock.Code > 0 && this.hasLocalStockDealers() && this.hasSelectedDealer) {
                    // scenario 2: local stock dealers AND selected dealer AND stock > 0
                    enable = true;
                }
                else if (this.product && this.product.Product && item && item.stock.IsRetailDirectToConsumer) {
                    // scenario 3: RD2C
                    enable = true;
                }

                return enable;
            },
            setActiveDealers(showAllDealers = false) {

                console.log("setActiveDealers() - showAllDealers : " + showAllDealers);

                if (showAllDealers || this.isLocalStockOnlyMode == false) {
                    // Set active dealers to all available dealers.
                    // Sort by distance, smallest distance first.
                    this.activeDealers = this.warehouseAndlocalstockDealersWithinRadius
                        .slice()
                        .sort(function (a, b) {
                            return a.Distance - b.Distance;
                        });
                } else {

                    if (this.hasLocalStockDealers()) {
                        // scenario: local dealers
                        this.isDealerListVisible = true;
                        //show dealer search
                        this.isDealerSearchFieldEnabled = true;

                        console.log("show all local dealers inside and outside radius");
                        // scenario: local dealers outside radius only
                        this.activeDealers = this.localstockDealers;
                    }

                    // in roadtrip mode always show list
                    if (this.isWillingToTakeARoadTrip == true) {
                        this.isDealerListVisible = true;
                    }

                }

                // loading done
                this.loadingDealers = false;

            },
            onPickupAtAnyRetailerClick() {
                // this is warehouse mode
                this.isLocalStockOnlyMode = false

                // Set Active dealers with showAllDealers = true
                this.setActiveDealers(true)

                // show dealers list, searchfield and filter
                this.isDealerListVisible = true
                this.isDealerSearchFieldEnabled = true
            },
            onRetailersNearCityClick() {
                this.showLocalStockDealers()
            },
            onRoadTripDealersClick() {
                console.log("on road trip dealers click");
                // set to road trip mode
                this.isWillingToTakeARoadTrip = true;
                // show local dealers
                this.showLocalStockDealers()
            },
            showLocalStockDealers() {
                // set mode to local
                this.isLocalStockOnlyMode = true;

                // show dealers list, search
                this.isDealerListVisible = true
                this.isDealerSearchFieldEnabled = true
                this.isAvailableInTextVisible = true

                // set Active dealers
                this.setActiveDealers()
            },
            isLocalStockFilterCheckboxVisible() {
                var hasLocalAndWarehouseStock = this.dealers.findIndex(x => x.Type == 'local') > -1 && this.dealers.findIndex(x => x.Type == 'warehouse') > -1 && this.isDealerListVisible;
                return hasLocalAndWarehouseStock;
            },
            toggleLocalStockOnlyMode() {
                this.setActiveDealers(!this.isLocalStockOnlyMode)
            },
            setClientLocation(item, callback, that, skipCountry) {
                var thisParent = this
                window.getLatLng(item + (skipCountry == true ? '' : ' ' + window.country), function (lat, lng) {
                    if (lat != null) {
                        var clientlocation = { city: item, lat: lat, lng: lng }
                        vueStore.commit('setClientLocation', clientlocation)
                        document.cookie = 'clientLocation=' + JSON.stringify(clientlocation) + '; path=/' + window.culture;

                        if (callback) {
                            callback(that, lat, lng)
                        }
                    } else if (skipCountry == true) {
                        //stop trying....
                        if (callback) {
                            callback(that, lat, lng)
                        }
                    } else {
                        //try to find without country suffix
                        thisParent.setClientLocation(item, callback, that, true)
                    }
                })
            },
            getClientLocation() {
                var clientLocation = window.readCookie('clientLocation')
                if (clientLocation != null) {
                    try {
                        vueStore.commit('setClientLocation', JSON.parse(clientLocation))
                    } catch (e) {
                        console.log(e);
                    }
                }
            },
            getBrowserLocation(callback) {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        var latlng = new window.google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                        var geocoder = new window.google.maps.Geocoder();
                        geocoder.geocode({ latLng: latlng }, function (results, status) {
                            var city = '';
                            if (status == window.google.maps.GeocoderStatus.OK) {
                                if (results[1]) {
                                    var arrAddress = results;
                                    console.log(results);
                                    for (var i = 0; i < arrAddress.length; i++) {
                                        if (arrAddress[i].types[0] == "locality") {
                                            console.log("dealercity: " + arrAddress[i].address_components[0].long_name);
                                            city = arrAddress[i].address_components[0].long_name;
                                        }
                                    }

                                    if (city.length == 0) {
                                        //try to find by administrative_area_level_4
                                        for (var j = 0; j < arrAddress.length; j++) {
                                            if (arrAddress[j].types[0] == "administrative_area_level_4") {
                                                console.log("dealercity: " + arrAddress[j].address_components[0].long_name);
                                                city = arrAddress[j].address_components[0].long_name;
                                            }
                                        }
                                    }
                                    if (city.length == 0) {
                                        //try to find by postal_town
                                        for (var k = 0; k < arrAddress.length; k++) {
                                            if (arrAddress[i].types[0] == "postal_town") {
                                                console.log("dealercity: " + arrAddress[k].address_components[0].long_name);
                                                city = arrAddress[k].address_components[0].long_name;
                                            }
                                        }
                                    }
                                } else {
                                    city = window.lblNoLocationFound;
                                }
                            } else {
                                //Raygun.send("Google Maps Geocoder exception. Status: " + status);
                                city = "Geocoder failed due to: " + status;
                            }

                            var clientlocation = { city: city, lat: position.coords.latitude, lng: position.coords.longitude }
                            vueStore.commit('setClientLocation', clientlocation)
                            document.cookie = 'clientLocation=' + JSON.stringify(clientlocation) + '; path=/' + window.culture;
                            if (callback) {
                                callback();
                            }
                        });
                    }, function () {
                        if (callback) {
                            callback();
                        }
                    }, { timeout: 5000 });//5sec
                }
            },
            toggleNotifyMeForm() {
                this.isNotifyMeVisible = !this.isNotifyMeVisible;

                //track GA
                window.trackEventGlobalAndLocal('Notify me when available', 'Click', document.title);
            },
            cloudinaryImageByPartnumberCode(partnumberCode) {
                for (var i = 0; i < this.product.Product.CloudinaryImagesToPartnumbers.length; i++) {
                    for (var j = 0; j < this.product.Product.CloudinaryImagesToPartnumbers[i].PartnumberCodes.length; j++) {
                        if (this.product.Product.CloudinaryImagesToPartnumbers[i].PartnumberCodes[j] == partnumberCode) {
                            return this.product.Product.CloudinaryImagesToPartnumbers[i];
                        }
                    }
                }
            }
            //isShippingOptionAvailable(shippingoption) {
            //    return (this.partnumber != null
            //        && this.partnumber.stock.Code != 0
            //        && (this.partnumber.stock.Code != 2 || shippingoption.DeliveryTypeToString == 'pickup')
            //        && (shippingoption.DeliveryTypeToString != 'homedelivery' || this.warehouseAndlocalstockDealersWithinHomeDeliveryRadius.length > 0) //homedelivery only if client within radius of dealer
            //    );
            //},
            //isShippingOptionAvailable(shippingoption) {
            //    if (this.partnumber == null) {
            //        return { result: false, message: 'No partnumber selected' };
            //    } else if (this.partnumber.stock.Code == 0) {
            //        return { result: false, message: 'No warehouse and local stock' };
            //    } else if (shippingoption.DeliveryTypeToString == 'homedelivery' && this.warehouseAndlocalstockDealersWithinHomeDeliveryRadius.length == 0) {
            //        return { result: false, message: 'No dealer is able to deliver this bike within his radius' };
            //    } else {
            //        return { result: true };
            //    }
            //},
            //isShippingAvailable() {
            //    if (this.product != null && this.product.ShippingOptions != null && this.product.ShippingOptions.length > 0) {
            //        for (var i = 0; i < this.product.ShippingOptions.length; i++) {
            //            if (this.isShippingOptionAvailable(this.product.ShippingOptions[i]).result) {
            //                return true;
            //            }
            //        }
            //    }
            //    return false;
            //},
            //getFirstShippingOptionAvailable() {
            //    if (this.product != null && this.product.ShippingOptions != null && this.product.ShippingOptions.length > 0) {
            //        for (var i = 0; i < this.product.ShippingOptions.length; i++) {
            //            if (this.isShippingOptionAvailable(this.product.ShippingOptions[i]).result) {
            //                return this.product.ShippingOptions[i];
            //            }
            //        }
            //    }
            //    return null;
            //},
        },
        computed: {
            partnumber() {
                return vueStore.state.partnumber
            },
            selectedDealer() {
                return vueStore.state.dealer
            },
            apiUrl() {
                return '/' + window.culture + '/shop/productselector/' + this.id + '/' + this.producttypeid + '/true'
            },
            product() {
                return vueStore.state.product
            },
            color: {
                get() {
                    return vueStore.state.color
                },
                set(value) {
                    vueStore.commit('setColor', value)
                }
            },
            partnumbersByColor() {
                var partnumbers = [];

                //if (this.hasUsage) {
                //    partnumbers = this.product.Partnumbers;
                //} else {
                //    partnumbers = this.product.Partnumbers?.filter(x => x.color == this.color);
                //}

                if (this.hasUsage) {
                    partnumbers = this.product.Partnumbers;
                } else {
                    partnumbers = this.product.Partnumbers?.filter(x => x.color == this.color);
                }

                if (partnumbers.length == 0) {
                    //voor uitzonderingen als een product een usage heeft of zoals CONTACT SLR AEROLIGHT STEM alle partnumbers tonen
                    partnumbers = this.product.Partnumbers;
                }

                //set default partnumber if it's only 1 partnumber
                if (partnumbers != null && partnumbers.length == 1) {
                    this.setPartnumberAndGetDealers(partnumbers[0]);
                }

                //set default partnumber it's in querystring
                if (this.partnumber == null && window.location.search.length > 0) {
                    let uri = window.location.search.substring(1);
                    let params = new URLSearchParams(uri);
                    if (params.get("partnumber") != null && this.product.Partnumbers?.filter(x => x.code == params.get("partnumber")).length > 0) {
                        this.setPartnumberAndGetDealers(this.product.Partnumbers?.filter(x => x.code == params.get("partnumber"))[0]);
                    }
                }

                return partnumbers;
            },
            GAclientId() {
                var ga_clientId;
                try {
                    if (window.ga.getAll()[0].get('clientId') != undefined) {
                        ga_clientId = window.ga.getAll()[0].get('clientId');
                    }
                } catch (e) {
                    //do nothing
                }
                return ga_clientId;
            },
            isSellable() {
                return this.product.Partnumbers?.filter(x => x.stock != null && x.stock.Code != 0).length > 0
            },
            sellLocalStock() {
                return this.product.SellLocalStock;
            },
            isSoldOut() {
                return this.isSellable == false && this.product.Partnumbers?.filter(x => x.notifyMe == true).length == 0
            },
            isNotifyMe() {
                return this.isSellable == false && this.product.Partnumbers?.filter(x => x.notifyMe == true).length > 0
            },
            hasUsage() {
                return this.product.Partnumbers?.filter(x => x.hasUsage == true).length > 0
            },
            dealers() {
                return vueStore.state.dealers
            },
            warehouseDealers() {
                if (this.dealers && this.dealers.length) {
                    return this.dealers.filter(x => x.Type == 'warehouse');
                } else {
                    return [];
                }
            },
            localstockDealers() {
                if (this.dealers && this.dealers.length) {
                    return this.dealers.filter(x => x.Type == 'local');
                } else {
                    return [];
                }
            },
            localstockDealersWithinRadius() {
                if (this.dealers && this.dealers.length) {
                    return this.dealers.filter(x => x.Type == 'local' && x.IsDealerWithinRadius);
                } else {
                    return [];
                }
            },
            warehouseAndlocalstockDealersWithinRadius() {
                if (this.dealers && this.dealers.length) {
                    return this.dealers.filter(x => x.IsDealerWithinRadius);
                } else {
                    return [];
                }
            },
            warehouseAndlocalstockDealersWithinHomeDeliveryRadius() {
                if (this.dealers && this.dealers.length) {
                    return this.dealers.filter(x => x.IsDealerWithinHomeDeliveryRadius);
                } else {
                    return [];
                }
            },
            hasSelectedDealer() {
                var dealerSelected = false;
                if (this.selectedDealer && this.selectedDealer?.Code) {
                    dealerSelected = true;
                }
                console.log("dealerSelected: " + dealerSelected);
                return dealerSelected;
            },
            clientLocation() {
                return vueStore.state.clientLocation
            },

            addOns() {
                return this.product.Product?.AddOns;
            },
            bundles() {
                return this.product.BundleItems;
            },
            //shippingOption: {
            //    get() {
            //        return vueStore.state.shippingOption
            //    },
            //    set(value) {
            //        vueStore.commit('setShippingOption', value)
            //        this.setActiveDealers();
            //    }
            //},
            //shippingLabel() {
            //    var result = {
            //        label1: 'To view availability',
            //        label2: 'Enter location',
            //        href: ''
            //    };
            //    var _shippingOption = this.shippingOption;
            //    if (_shippingOption != null && this.clientLocation != null && this.clientLocation.city != null && this.clientLocation.city.length > 0) {

            //        if (_shippingOption.DeliveryTypeToString == 'pickup' && this.partnumber.stock.Code == 2) {
            //            result.label1 = "In stock at";
            //            if (this.selectedDealer) {
            //                result.label2 = this.selectedDealer.Name + ' - ' + this.selectedDealer.City + ' (' + this.selectedDealer.DistanceToFormat + ' miles)';
            //            }
            //        }
            //        else if (_shippingOption.DeliveryTypeToString == 'pickup') {
            //            result.label1 = "Ready to ship to";
            //            if (this.selectedDealer) {
            //                result.label2 = this.selectedDealer.Name + ' - ' + this.selectedDealer.City + ' (' + this.selectedDealer.DistanceToFormat + ' miles)';
            //            }
            //        } else {
            //            result.label1 = "Ready to ship to your location in";
            //            result.label2 = this.clientLocation.city;
            //            if (this.selectedDealer) {
            //                result.label2 += ' by ' + this.selectedDealer.Name + ' - ' + this.selectedDealer.City + ' (' + this.selectedDealer.DistanceToFormat + ' miles)';
            //            }
            //        }
            //    }
            //    return result;
            //}
            showDealerSelector() {
                return this.partnumber.stock.IsRetailDirectToConsumer == false || this.setShowDealerSelector == true;
            },
            inProgressAddingProductToCart() {
                return vueStore.state.addingProductToCart
            },
            showNotifyMe() {
                return this.partnumber && this.partnumber.stock.Code == 0 && this.product.Partnumbers.length > 1 || this.isNotifyMeVisible == true;
            }
        },
        beforeMount() {
            this.fetchApi()
            this.getClientLocation();
            if (this.clientLocation != null && this.clientLocation.city != null) {
                this.dealerSearchCity = this.clientLocation.city
            } else {
                var that = this;
                this.getBrowserLocation(function () {
                    if (that.clientLocation != null && that.clientLocation.city != null) {
                        that.dealerSearchCity = that.clientLocation.city
                    } else {
                        that.dealerSearchCity = window.defaultCityEnglish;
                    }
                });
            }
        },
        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-parameters').dataset.interfacetexts);
            this.pickupAvailable = document.getElementById('vue-product-selector').dataset.pickupavailable == 'true';
            this.showShippingCostsAtProductSelector = document.getElementById('vue-product-selector').dataset.showshippingcostsatproductselector == 'true';
            this.id = document.getElementById('vue-product-selector').dataset.productid;
            this.producttypeid = document.getElementById('vue-product-selector').dataset.producttypeid;
            this.partnumberDefault = document.getElementById('vue-product-selector').dataset.partnumberdefault;
            this.showBikeAdvancedSizingTool = document.getElementById('vue-product-selector').dataset.showbikeadvancedsizingtool == 'true';
            this.viewmode = document.getElementById('vue-parameters').dataset.viewmode;
        }
    }
</script>
